import { styled, SvgIcon } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CIButton } from 'common/viewcomp/forms/buttons';
import { ReactComponent as LinkOutIcon } from 'img/linkout.svg';

interface OktaErrorDisplayProps {
    error: any;
    onGoToLogin: () => void;
}

export const OktaErrorDisplay = ({ error, onGoToLogin }: OktaErrorDisplayProps) => {
    const { t } = useTranslation('auth');

    return (
        <div id="okta-sso-page">
            <div className="error">
                <ErrorHeader>{t('login.sso.error.header')}</ErrorHeader>
                <ErrorTitle>
                    {t('login.sso.error.general_description', {
                        message: error?.message || error?.name,
                    })}
                </ErrorTitle>
                {error?.errorSummary && <ErrorDescription>{error.errorSummary}</ErrorDescription>}
                <ActionWrapper>
                    <SupportButton
                        href={t('support_link')}
                        endIcon={<SvgIcon component={LinkOutIcon} viewBox="0 0 20 20" />}
                    >
                        {t('contact_support')}
                    </SupportButton>
                    <HomeButton onClick={onGoToLogin}>{t('password.back_to_login')}</HomeButton>
                </ActionWrapper>
            </div>
        </div>
    );
};

const ErrorTitle = styled('div')({
    fontSize: '1.15rem',
    marginBottom: '1em',
});

const ErrorHeader = styled('div')({
    fontSize: '1.5rem',
    fontWeight: 700,
    marginBottom: '1em',
    lineHeight: '1.1em',
});

const ActionWrapper = styled('div')({
    marginTop: '2em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    alignContent: 'center',
});

const ErrorDescription = styled('div')({
    fontSize: '1.1rem',
    marginInlineStart: '1em',
    marginBottom: '0.5em',
    textAlign: 'start',
    lineHeight: '1.15em',
    wordWrap: 'break-word',
    maxHeight: '10em',
    overflowY: 'auto',
});

const HomeButton = styled(CIButton)(({ theme }) => ({
    color: theme.ciPalette.common.white,
    backgroundColor: theme.ciPalette.common.blue,

    '&:hover': {
        backgroundColor: theme.ciPalette.common.blue,
    },
}));

const SupportButton = styled(CIButton)(({ theme }) => ({
    color: theme.ciPalette.common.white,
    backgroundColor: theme.ciPalette.common.lighterOrange,

    '&:hover': {
        color: theme.ciPalette.common.white,
        backgroundColor: theme.ciPalette.common.lighterOrange,
    },
}));
